import { render, staticRenderFns } from "./MateriePrimePers.vue?vue&type=template&id=9a1aadee"
import script from "./MateriePrimePers.vue?vue&type=script&lang=js"
export * from "./MateriePrimePers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports